
































import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class TDPointPopup extends Vue {
  @PropSync("show", { type: Boolean }) visible!: boolean;
  @Prop({ required: true }) point!: TenderDispath.TenderDispathPoint;
  /* Data */
  notes = "" as string;

  /* Hooks */
  mounted() {
    this.notes = this.point.notes;
  }

  /* Watch*/
  @Watch("point") onPoint() {
    if (this.point) {
      this.notes = this.point.notes;
    }
  }

  /* Methods */
  close() {
    this.visible = false;
  }

  remove() {
    this.$emit("onRemove", this.point);
    this.close();
  }

  confirm() {
    this.point.notes = this.notes;
    this.$emit("onConfirm", this.point);
    this.clearNotes();
    this.close();
  }

  clearNotes() {
    this.notes = "";
  }
}
